import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faInfoCircle, faBook } from '@fortawesome/free-solid-svg-icons'

class FileIconRow extends PureComponent {

  originalMetadata() {
    if (this.props.file.originalMetadata !== undefined && this.props.file.originalMetadata) {
      return (
        <FontAwesomeIcon icon={faCheckCircle} fixedWidth title="Used for Item Metadata" />
      )
    }
  }

  scrapeMetadata() {
    if (this.props.file.scrapeMetadata !== undefined && this.props.file.scrapeMetadata) {
      return (
        <FontAwesomeIcon icon={faInfoCircle} fixedWidth title="Has Scraped Metadata" />
      )
    }
  }

  published() {
    if (this.props.file.published) {
      return (
        <FontAwesomeIcon icon={faBook} fixedWidth title="Published" />
      )
    }
  }

  render() {
    return (
      <div className="table-icon-right">
        { this.originalMetadata() }
        { this.scrapeMetadata() }
        { this.published() }
      </div>
    )
  }
}

FileIconRow.propTypes = {
  file: PropTypes.shape({
    originalMetadata: PropTypes.any,
    scrapeMetadata: PropTypes.any,
    published: PropTypes.bool,
    location: PropTypes.string
  })
}

export default FileIconRow